import { Component, Input, Output, EventEmitter, ViewChildren, ViewContainerRef, QueryList, forwardRef } from '@angular/core';

import { HisAuthService, HisUiService, HisConfirmationService,
    HisBaseGlobalsService, HisAbstractControlValueAccessor } from 'hisng';

import { CONFIRMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/confirmation-dialog.component';
import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { AmountFormatterUtils } from 'app/fs/res/common/utils/amount-formatter-utils';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { PatentInventor } from 'app/fs/res/patent/model/patent/patent-classes';
import { Patent } from 'app/fs/res/patent/model/patent/patent';

@Component( {
    selector: 'res-patent-edit-inventors',
    templateUrl: './patent-edit-inventors.component.html',
    providers: [ProviderManager.getComponentProvider(PatentEditInventorsComponent),
        ProviderManager.getValueAccessorProvider(PatentEditInventorsComponent) ],
} )
export class PatentEditInventorsComponent extends HisAbstractControlValueAccessor {
    @Input() patent: Patent = new Patent(); // ngModel
    @Output() inventorsChange: EventEmitter<PatentInventor[]> = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    public patentInventor: PatentInventor;

    public selectedInventors: any[] = []; // his-search-select-popup Parameter  // TODO:DELETE
    public visibility = false;
    public externalInventorVisibility = false;
    public internalInventorVisibility = false;

    constructor( public auth: HisAuthService,
        private hisUiService: HisUiService,
        private confirmationService: HisConfirmationService,
        private hisBaseGlobalsService: HisBaseGlobalsService ) {
        super();
    }

    /** edit inventor data (for internal person just percentage / for external full object) */
    public editInventor( inventor: PatentInventor ) {
        // Differ internal and external organisation
        if( inventor.organization ) {
            this.patentInventor = inventor;
            this.internalInventorVisibility = true;
        } else {
            this.patentInventor = inventor;
            this.externalInventorVisibility = true;
        }
    }

    public createInventor( mode: string ) {
        this.patentInventor = null;
        if ( mode === 'INTERN' ){
            this.internalInventorVisibility = true;
        } else {
            this.externalInventorVisibility = true;
        }
    }

    /**
     * delete inventor from patent list.
     *
     * @param inventor Inventor of Patent to delete
     */
    public deleteInventor( inventor: PatentInventor ): void {
        this.patent.inventors = this.patent.inventors.filter( inv => inv !== inventor );
        this.inventorsChange.emit( this.patent.inventors );
    }

    /**
     * Format the patent.inventors.percentage with the correct decimalSplitter
     */
    public formatPercentage( percentage: number ): string {
        return AmountFormatterUtils.formatDecimalNumber( percentage, this.hisBaseGlobalsService.getLanguage() );
    }

    /* confirmation dialog if percentage values for each inventor should be overridden */
    public percentageOverride() {
        if ( this.patent.inventors.find( i => i.percentage != null ) != null ) {
            this.confirmationService.confirm( {
                key: CONFIRMATION_PDIALOG_KEY,
                message: this.hisUiService.translate( 'fs.res.patent.percentage.overrideInfo' ),
                header: this.hisUiService.translate( 'fs.res.common.confirmation' ),
                accept: () => {
                    this.percentageAuto();
                },
            } );
        } else {
            this.percentageAuto();
        }
    }

    /**
     * calculate percentage for each person in table
     */
    private percentageAuto() {
        let percentage: number = 100 / this.patent.inventors.length;
        this.patent.inventors.forEach( i => {
            i.percentage = parseFloat( percentage.toFixed( 2 ) );
        } );
    }

    public savePatentInventorChange( event: PatentInventor ) {
        // if entry is new and it not existing in this.patent.inventors array
        this.patent.inventors.push(event);this.onModelChange(this);
    }
}
